import { DealerAuctionDTO } from "@/src/types/types";

export const filterHiddenAuctions = (
  auctions: DealerAuctionDTO[],
  showHiddenAuctions: boolean
): DealerAuctionDTO[] => {
  if (showHiddenAuctions) {
    return auctions;
  }
  return auctions.filter((auction) => !auction.isHidden);
};

export const hasHiddenAuctions = (auctions: DealerAuctionDTO[]): boolean =>
  auctions.some((auction) => auction.isHidden);

export const countHiddenAuctions = (auctions: DealerAuctionDTO[]): number =>
  auctions.filter((auction) => auction.isHidden).length;

/**
 * Normalizes auction id for wizard persistence when only numeric ids are valid.
 */
export const resolveAuctionId = (
  id: number | string | undefined | null
): number | undefined => {
  if (typeof id === "number") {
    return id;
  }
  return undefined;
};

/**
 * Builds a path with an optional query string (no nested template literals).
 */
export const pathnameWithOptionalQuery = (
  pathname: string,
  queryString: string
): string => (queryString.length > 0 ? pathname + "?" + queryString : pathname);
